import React, { useState } from 'react';
import './Footer.css'
import Logo from '../Logo/Logo';
import { Link } from 'react-router-dom';

const Footer = ({ darkmodeClass, setMenuOpen, clearFilters}) => {
  const [activeSection, setActiveSection] = useState('');

  const handleClick = () => {
    // Scroll to the top of the page
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleLinkClick = (sectionClass) => {
    setActiveSection(sectionClass);


    const sectionElement = document.querySelector(`.${sectionClass}`);
    if (sectionElement) {
      let scrollToPosition;

      // Adjust the scroll position based on screen size
      if (window.innerWidth <= 768) {
        // Small screen
        scrollToPosition = sectionElement.getBoundingClientRect().top + window.scrollY - 300;
      } else {
        // Large screen
        scrollToPosition = sectionElement.getBoundingClientRect().top + window.scrollY - 300;
      }

      // Scroll to the calculated position
      window.scrollTo({ top: scrollToPosition, behavior: 'smooth' });
    }
  };

  return (
    <footer className={`footer ${darkmodeClass}`}>
      <div className={`footer-content ${darkmodeClass}`}>
        <div className={`footer-content1 ${darkmodeClass}`}>
          <div className={`logo-container1 ${darkmodeClass}`}>
            <Link to="/" className={`flogo ${darkmodeClass}`} onClick={handleClick}>
            <Logo clearFilters={clearFilters} setMenuOpen={setMenuOpen} darkmodeClass={darkmodeClass}/>
            </Link>
          </div>
          <div className='fp'>
            <p className={`${darkmodeClass}`}>
              Over 4.5 million+ high quality stock images, videos and music shared by our talented community.
            </p>
          </div>
          <div className={`footer-social ${darkmodeClass}`}>
            <a href="www.linkedin.com/in/rakkkkkesh" target="_blank"><i class="uil uil-linkedin-alt home__icon" className={`fa-brands fa-linkedin ${darkmodeClass}`}></i></a>
            <a href="https://twitter.com/rakkkesh_" target="__blank"><i className={`fa-brands fa-x-twitter ${darkmodeClass}`}></i></a>
            <a href="https://www.instagram.com/rakkkesh_/" target="__blank"><i className={`fab fa-instagram ${darkmodeClass}`}></i></a>
            <a href="mailto:rakeshpyadav2615@gmail.com" target="_blank"><i className={`fa-solid fa-envelope ${darkmodeClass}`}></i></a>
          </div>
        </div>
        <div className={`footer-content2 ${darkmodeClass}`}>
          <div className={`discover ${darkmodeClass}`}>
            <h4 className={`${darkmodeClass}`}>Discover</h4>
            <p><Link to="/" className={`${darkmodeClass}`} onClick={handleClick}>Editor's Choice</Link></p>
            <p><Link to="/" className={`${darkmodeClass}`} onClick={handleClick}>Explore, Create, Share</Link></p>
          </div>
          <div className={`about ${darkmodeClass}`}>
            <h4 className={`${darkmodeClass}`}>About</h4>
            <p><Link to="/about" className={`link ${darkmodeClass}`} onClick={handleClick}>About Us</Link></p>
            <p><Link to="/about" className={`link ${darkmodeClass}  ${activeSection === 'vision' ? 'active' : ''}`} onClick={() => handleLinkClick('vision')}>Our vision</Link></p>
            <p><Link to="/about" className={`link ${darkmodeClass}  ${activeSection === 'commitment' ? 'active' : ''}`} onClick={() => handleLinkClick('commitment')}>our Commitment</Link></p>
          </div>
          <div className={`community ${darkmodeClass}`}>
            <h4 className={`${darkmodeClass}`}>Terms of Use</h4>
            <p><Link to="/services" className={`link ${darkmodeClass} ${activeSection === 'general-section' ? 'active' : ''}`} onClick={() => handleLinkClick('general-section')}>Privacy Policy</Link></p>
            <p><Link to="/services" className={`link ${darkmodeClass} ${activeSection === 'license-section' ? 'active' : ''}`} onClick={() => handleLinkClick('license-section')}>License Summary</Link></p>
            <p><Link to="/services" className={`link ${darkmodeClass} ${activeSection === 'terms-container' ? 'active' : ''}`} onClick={() => handleLinkClick('terms-container')}>Terms of Service</Link></p>
          </div>
        </div>
      </div>
      <div className={`footer-bottom ${darkmodeClass}`}>
        <p className={`${darkmodeClass}`}>&copy; {new Date().getFullYear()} Pixabay. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
